import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Box } from '@chatterbug/aaron'

import { TYPES } from 'src/pages/Achievements/subcomponents/AchievementWidget/AchievementWidget'

const AchievementWidgetBodySkeleton = ({
  titleSection,
  imageSection,
  detailSection,
  widgetType = 'media',
  showPlaceholder = false,
  isList,
}) => {
  // the complex adjustment to empty states and different widgets
  const getRowStyle = () => {
    if (showPlaceholder) {
      if (widgetType === TYPES.LIVE_LESSON || widgetType === TYPES.FLASHCARDS) {
        return { _: '1', tablet: 'auto' }
      } else {
        return { _: '1', tablet: null }
      }
    }
  }

  const getColumnStyle = () => {
    if (showPlaceholder) {
      if (widgetType === TYPES.LIVE_LESSON || widgetType === TYPES.FLASHCARDS) {
        return 'auto'
      } else {
        return { _: '1/span 2', tablet: null }
      }
    } else if (isList) {
      return 'auto'
    } else if (widgetType === TYPES.LIVE_LESSON) {
      return { _: '1/span 2', tablet: 'auto' }
    }
  }

  return (
    <Grid
      gridTemplateColumns={
        isList
          ? '200px 1fr'
          : showPlaceholder
          ? 'auto'
          : widgetType === TYPES.LIVE_LESSON
          ? { _: '1fr', tablet: '326px 1fr', desktop: '452px 1fr' }
          : '112px 1fr'
      }
    >
      <Box gridColumn="1/span 2">{titleSection}</Box>
      <Box
        gridRow={getRowStyle()}
        gridColumn={getColumnStyle()}
        textAlign="center"
        // block because for some reason flex and div doesn't work
        display={isList ? { _: 'none', tablet: 'flex' } : 'block'}
      >
        {imageSection}
      </Box>
      <Box
        ml={
          isList
            ? '5x'
            : widgetType === TYPES.LIVE_LESSON
            ? { _: 0, tablet: '5x' }
            : '2x'
        }
      >
        {detailSection}
      </Box>
    </Grid>
  )
}

AchievementWidgetBodySkeleton.propTypes = {
  imageSection: PropTypes.any.isRequired,
  detailSection: PropTypes.any.isRequired,
  titleSection: PropTypes.any,
  widgetType: PropTypes.string,
  showPlaceholder: PropTypes.bool,
  isList: PropTypes.bool,
}

export default AchievementWidgetBodySkeleton
